import React, { useState, useEffect } from 'react';
import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  EditButton,
  TextField,
  ImageField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  BooleanField,
  EmailField,
  NumberField,
  useRecordContext,
  useResourceContext,
  useGetOne
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  GetCurrentUserRoles,
} from "../common/common";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
const apiUrl = RUN_TIME_API_ENDPOINT;

const ListingModal = (props) => {

  const location = useLocation();
  const record = useRecordContext();
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState(1);


  useEffect(() => {
    console.log("callllllllled", location)
    // Update the document title using the browser API
    let _paramsUrl = location.pathname.split("/");
    console.log("_paramsUrl", _paramsUrl)

    if (_paramsUrl.length > 1 && _paramsUrl[2] !== "") {
      console.log("params found", _paramsUrl[2]);
      setUserId(_paramsUrl[2]);
    }
  }, []);

  const onSave = (record) => {
    console.log(
      "user_entity_mapping_status",
      record.user_entity_mapping_status
    );
    const url = `${apiUrl}/user_entity_mappings/${userId}/businesses/${record.id}`;
    const data = {
      status: String(!JSON.parse(record.user_entity_mapping_status)),
      id: record.id,
      ids: record.ids,
    };
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify(data);
    console.log(data);
    Swal.fire({
      text: "Please wait while your request is being processed.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    return fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json);
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  const openListingModal = () => {
    let _paramsUrl = window.location.href.split("?");
    if (_paramsUrl.length > 1 && _paramsUrl[1] !== "") {
      console.log("params found", _paramsUrl);
    }
    setOpen(true)
  };

  const onCloseModal = () => {
    setOpen(true);
  };

  const onToggle = () => {
    console.log("user_entity_mapping_status", record)
    let settingValue =
      record.user_entity_mapping_status !== true ? "ON" : "OFF";
    Swal.fire({
      text:
        "Are you sure to change the value of " +
        record.user_entity_mapping_status +
        " to " +
        settingValue +
        ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        onSave(record);
      }
    });
  };

  let recordValue = record.user_entity_mapping_status ? "ON" : "OFF";
  let settingValue =
    record.user_entity_mapping_status !== true ? "ON" : "OFF";
  console.log("provvvvvvvvvvvps", recordValue);
  return (
    <div>
      <div
        className={`toggle-button-container ${recordValue === "ON" ? "toggle-button-on" : ""
          }`}
      >
        <label className="switch">
          <input
            type="checkbox"
            checked={recordValue === "ON"}
            onChange={openListingModal}
          />{" "}
          <div></div>
        </label>
        <span className="switch-status">{recordValue}</span>
      </div>
      {open && onToggle(props)}
    </div>
  );
}

const CustomEditButton = ({ record, basePath }) => {
  console.log("custom show", record, basePath);
  const { data } = useGetOne(
    'users',
    { id: record?.id }
  );
  return (
    <div>
      <EditButton to={`${basePath}/${record?.id}`} />
      {/* <EditButton basePath={basePath} /> */}
    </div>
  );
};

const ShowActions = () => {
  const record = useRecordContext();
  console.log("record....Show", record);
  const resource = useResourceContext();
  return (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={resource} />
      <EditButton basePath={resource} record={record} id={record?.id} />
    </TopToolbar>
  );
}

const ShowTitle = () => {
  const record = useRecordContext();
  return record && <span>User {record.first_name}</span>;
};

const ClickItUserShow = ({ permissions, ...props }) => {
  console.log("props ==>", props);
  const { id } = props;
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  let locale = getLocalStorageKey("locale");

  return (
    <Show
      actions={<ShowActions permissions={permissions} id={id} />}
      {...props}
      title={<ShowTitle />}
    >
      <TabbedShowLayout Class="tab-scroll">
        <Tab label="User Details" contentClassName="scrollTab">
          <TextField source="first_name" />
          <TextField source="last_name" />
          <TextField source="address" />
          <EmailField source="email" />
          <TextField source="phone" />
          <ImageField
            source="profile_image_data"
            title="Profile Image"
            label="Profile"
          />
          <BooleanField source="is_tnc_accepted" title="tnc Accepted" />
          <BooleanField source="is_super" title="super" />
          <TextField source="role_name" />
          <BooleanField source="status" title="status" />
          {locale == "ar-EG" && <BooleanField source="is_payment_enable" label='Payment available' />}
          <DateField source="tnc_accepted_at" showTime options={{  day: 'numeric',month: 'numeric',year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true}}/>
          <DateField source="tnc_rejected_at" showTimeoptions={{  day: 'numeric',month: 'numeric',year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true}}/>
          <TextField source="updated_by_id" />
          <DateField source="updated_at" showTime options={{  day: 'numeric',month: 'numeric',year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true}}/>
          <DateField label="Created at" source="created_at" showTime options={{  day: 'numeric',month: 'numeric',year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true}}  />
        </Tab>

        <Tab label="Sold To">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="businesses"
            source="id"
            target="user_id"
            className="tab-pagination"
          >
            <List
              {...props}
              filterDefaultValues={{ user_id: businessIdVal }}
              sort={{ field: "created_at", order: "DESC" }}
              exporter={false}
              hasCreate={false}
              actions={false}
            >
              <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                <TextField source="name" />
                <TextField source="name_sap_code" />
                <TextField source="address" />
                <NumberField source="orders_not_invoiced_price" />
                <EmailField source="email" />
                <TextField source="phone" />
                <BooleanField source="tnc_accepted" title="tnc Accepted" />
                <NumberField source="sap_digital_order_balance" />
                <TextField source="sap_code" />
                <TextField source="total_credit_string" title="Total Credit" />
                {/* <BooleanField
                  source="user_entity_mapping_status"
                  title="status"
                /> */}
                <TextField source="user_name" />
                <DateField source="last_seen_at" />
                <BooleanField source="is_ordering_blocked" />
                <BooleanField source="is_sap_blocked" />
                <BooleanField source="is_sap_deleted" />
                {/* <ListingModal
                  source="status"
                  label="User Entity Mapping Status"
                /> */}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>

        <Tab label="Orders">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference={
              showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"
            }
            source="id"
            target="placed_order_user_id"
            className="tab-pagination"
          >
            <List
            className="tab-list"
              // {...props}
              filterDefaultValues={{ placed_order_user_id: businessIdVal }}
              exporter={false}
              hasCreate={false}
              actions={false}
            >
              <Datagrid rowClick="show" className="tab-data-grid" bulkActionButtons={false}>
                <DateField label="Order Date" source="creation_date" />
                <ReferenceField
                  label="Sold To Name"
                  source="business_id"
                  reference="businesses"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextField source="order_number" />
                <CamelCaseField
                  source="mode_of_delivery"
                  label="Mode Of Delivery"
                />
                <ExpectedDateField
                  label="Expected Date"
                  source="delivery_date_from"
                />
                <TextField
                  label="Local PO / Note"
                  source="customer_ref_number"
                />
                <TextField
                  label="Order Status"
                  source="customer_order_status_desc"
                />
                <ReferenceField
                  label="Ship To Name"
                  source="sap_business_site_id"
                  reference="sap_business_sites"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                {permissions === "isSap" && (
                  <DateField label="Date 1st seen in LR" source="created_at" />
                )}
                {permissions === "isSap" && showAllOrders && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default ClickItUserShow;
